module.exports = __webpack_public_path__ + "static/media/pdx-floor-4.5e4262b2.png";